/* Publish by EComposer at 2025-08-07 21:33:03*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8pnb396dtbj"]=  window.__ectimmers["ecom-8pnb396dtbj"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8pnb396dtbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8pnb396dtbj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y1dnqz05jp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y1dnqz05jp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cludil107wp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cludil107wp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4sitiloezh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4sitiloezh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-93telbnex6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-93telbnex6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nqb1ntof01k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nqb1ntof01k', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sxhjlhqvnea"]=  window.__ectimmers["ecom-sxhjlhqvnea"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-sxhjlhqvnea"]["eznfq10ac"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-sxhjlhqvnea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sxhjlhqvnea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4ipquczdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4ipquczdj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mv012fj5oc"]=  window.__ectimmers["ecom-mv012fj5oc"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-mv012fj5oc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mv012fj5oc', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cm0hfr1gqx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cm0hfr1gqx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mdzxn7rvb1i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mdzxn7rvb1i', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}